import { useRef } from 'react'
import { Marker } from 'react-leaflet'
import { useSearchParams } from 'react-router-dom'
import dayjs from 'dayjs'
import {
  createMarkerColor,
  isAuth,
  whatMarkerColor
} from 'utils/helpers'
import { v4 as uuid } from 'uuid'
import { ImagesPng } from 'assets/images'

export const CopyMarkerItem = ({
  item,
  mapRef,
  profileAvatar,
  isInsideOfCluster
}) => {
  const markerRef = useRef()
  let mouseDownOnMarkerRef = useRef(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const validDate = dayjs(item?.last_accessed)
  const iconMarker = createMarkerColor(
    validDate,
    profileAvatar ?? ImagesPng.DefaultImage,
    item?.is_friends,
    isAuth()
  )

  const handleClick = (e) => {
    if (isAuth()) {
      markerRef.current.closePopup()

      const trueLng = e.latlng.lng > 180 ? e.latlng.lng - 360 : e.latlng.lng + 360

      mapRef.current.setView([
        e.latlng.lat,
        trueLng
      ], localStorage.getItem('zoom'), { animate: true })

      setTimeout(() => setSearchParams({ id: item.id }), 300)
    }
  }

  const handleZIndexOffset = () => {
    const markerColor = whatMarkerColor(dayjs(item?.last_accessed))

    if (
      item?.is_friends !== 'accepted'
      && (
        markerColor !== 'green'
        || !isAuth()
      )
    ) {
      return -10000000
    }

    if (markerColor === 'green') {
      return item?.is_friends === 'accepted' ? 70000000 : 60000000
    }

    if (markerColor === 'yellow') {
      return item?.is_friends === 'accepted' ? 50000000 : 40000000
    }

    if (markerColor === 'red') {
      return item?.is_friends === 'accepted' ? 30000000 : 20000000
    }

    if (markerColor === 'gray') {
      return item?.is_friends === 'accepted' ? 10000000 : 0
    }

    return 9999
  }

  return (
    <Marker
      zIndexOffset={handleZIndexOffset()}
      eventHandlers={{
        click: (e) => handleClick(e),
        mousedown: () => {
          mouseDownOnMarkerRef.current = true
        },
        mouseup: (e) => {
          if (mouseDownOnMarkerRef.current && item?.coordinates[0] >= (84.5 * 2)) {
            handleClick(e)
          }

          mouseDownOnMarkerRef.current = false
        },
        mouseout: () => {
          mouseDownOnMarkerRef.current = false
        },
        touchStart: () => {
          mouseDownOnMarkerRef.current = true
        },
        touchEnd: (e) => {
          if (mouseDownOnMarkerRef.current && item?.coordinates[0] >= (84.5 * 2)) {
            handleClick(e)
          }

          mouseDownOnMarkerRef.current = false
        },
        touchCancel: () => {
          mouseDownOnMarkerRef.current = false
        }
      }}
      key={uuid()}
      icon={iconMarker}
      position={item?.coordinates}
      ref={markerRef}
      {...(isAuth() ? { title: item?.id } : {})}
      sx={{
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)',
        backfaceVisibility: 'hidden',
        willChange: 'transform'
      }}
    />
  )
}
